module.exports = __webpack_public_path__ + "static/media/class_job_034.9f821ea9.svg";